export default __webpack_public_path__ + "static/media/SndLowerYSlideDown2.e4c7769e.mp3";